var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "right" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn-small swb-btn",
              on: { click: _vm.exportPdf }
            },
            [_vm._v("导出pdf")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_vm._v("工单信息")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.no))]),
                          _vm._v(" "),
                          _vm.servcWorkVoucher.comnRepairFlag &&
                          !_vm.servcWorkVoucher.deviceFlag
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("日常维修")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.servcWorkVoucher.servcType != null
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.workServcTypeMap[
                                        _vm.servcWorkVoucher.servcType
                                      ]
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.servcWorkVoucher.remoted
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("远程解决")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.dlgtFlag
                            ? _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-danger" },
                                [_vm._v("委托")]
                              )
                            : _c("span", { staticClass: "swb-tags" }, [
                                _vm._v("否 ")
                              ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.dlgtFlag
                            ? _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-danger" },
                                [_vm._v("委托")]
                              )
                            : _c("span", { staticClass: "swb-tags" }, [
                                _vm._v("否 ")
                              ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.srcFlag != 0
                            ? _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-success" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkSrcFlagMap[
                                        _vm.servcWorkVoucher.srcFlag
                                      ]
                                    )
                                  )
                                ]
                              )
                            : _c("span", [_vm._v("无")])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.servcWorkVoucher.dlgtFlag
              ? _c("tr", { staticClass: "row" }, [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "info-item ",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _vm._m(5),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm.servcWorkVoucher.servcType ==
                                _vm.inspectValue &&
                              _vm.servcWorkVoucher.dlgtInspectFinished
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "swb-tags swb-tags-success"
                                    },
                                    [_vm._v("约检完成")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "info-item ",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _vm._m(6),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm.servcWorkVoucher.servcType ==
                                _vm.inspectValue &&
                              _vm.servcWorkVoucher.dlgtInspectFinishTime != null
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "swb-tags swb-tags-success"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.servcWorkVoucher
                                            .dlgtInspectFinishTime
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "info-item ",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _vm._m(7),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              (_vm.servcWorkVoucher.servcType ==
                                _vm.maintValue ||
                                _vm.servcWorkVoucher.dlgtInspectFinished) &&
                              _vm.servcWorkVoucher.dlgtMaintFinished
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "swb-tags swb-tags-success"
                                    },
                                    [_vm._v("约保完成")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "info-item ",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _vm._m(8),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              (_vm.servcWorkVoucher.servcType ==
                                _vm.maintValue ||
                                _vm.servcWorkVoucher.dlgtInspectFinished) &&
                              _vm.servcWorkVoucher.dlgtMaintFinishTime != null
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "swb-tags swb-tags-success"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.servcWorkVoucher
                                            .dlgtMaintFinishTime
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(9),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.tradeNo || ""))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(10),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.devcPartName || "")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(11),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.emgLevel == 0
                            ? _c("span", { staticClass: "font-green mr20" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.emgLevelMap[
                                      _vm.servcWorkVoucher.emgLevel
                                    ]
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.servcWorkVoucher.emgLevel == 1
                            ? _c("span", { staticClass: "font-orange mr20" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.emgLevelMap[
                                      _vm.servcWorkVoucher.emgLevel
                                    ]
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.servcWorkVoucher.emgLevel == 2
                            ? _c("span", { staticClass: "font-red mr20" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.emgLevelMap[
                                      _vm.servcWorkVoucher.emgLevel
                                    ]
                                  )
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(12),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.grabFlag &&
                                  _vm.servcWorkVoucher.grabIssuerType == 3
                                  ? "抢单"
                                  : "指派"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(13),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.closed
                            ? _c("label", { staticClass: "mr20 font-red" }, [
                                _vm._v("已关闭")
                              ])
                            : _vm.servcWorkVoucher.invalid
                            ? _c("label", { staticClass: "mr20 font-red" }, [
                                _vm._v("已作废")
                              ])
                            : _vm.servcWorkVoucher.grabFlag &&
                              _vm.servcWorkVoucher.grabIssuerType == 3 &&
                              _vm.servcWorkVoucher.engineerId == null
                            ? _c("label", { staticClass: "mr20 font-red" }, [
                                _vm._v("抢单中")
                              ])
                            : _c("label", { staticClass: "mr20" }, [
                                _vm._v(_vm._s(_vm.servcWorkVoucher.stateText))
                              ]),
                          _vm._v(" "),
                          _vm.servcWorkVoucher.stateText == "服务暂停"
                            ? _c("label", { staticClass: "font-red" }, [
                                _vm._v(
                                  ",原因：" +
                                    _vm._s(_vm.servcWorkVoucher.stateDesc)
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.servcWorkVoucher.evalFlag
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("已评价")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(14),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.reqVoucherNo))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(15),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.requestTime))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(16),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.yqFinishTime))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(17),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.createTime))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(18),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.creatorName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(19),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.servicerShopId == null
                            ? _c("label", [_vm._v("未指派")])
                            : _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.manualShopFlag
                                      ? "手工"
                                      : "自动"
                                  )
                                )
                              ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(20),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.engineerId == null
                            ? _c("label", [_vm._v("未指派")])
                            : _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.manualEngFlag
                                      ? "手工"
                                      : "自动"
                                  )
                                )
                              ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(21),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.beyondWrnt
                            ? _c("el-tag", { attrs: { type: "danger" } }, [
                                _vm._v("交易约定外")
                              ])
                            : _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("交易约定内")
                              ])
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(22),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.acceptByRequester
                            ? _c("span", [_vm._v("是")])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.servcWorkVoucher.acceptByRequester
                            ? _c("span", [_vm._v("否")])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  },
                  attrs: { colspan: "2" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(23),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        _vm._l(_vm.servcWorkVoucher.tagNames, function(
                          tagName
                        ) {
                          return _vm.servcWorkVoucher.hasTag
                            ? _c("span", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "swb-tags swb-tags-success mr5"
                                  },
                                  [_vm._v(_vm._s(tagName))]
                                )
                              ])
                            : _c(
                                "span",
                                {
                                  staticClass: "swb-tags swb-tags-success mr5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.servcWorkVoucher.retailerTag)
                                  )
                                ]
                              )
                        })
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcType == 2 &&
      _vm.servcWorkVoucher.devcSetupInfo != null &&
      _vm.servcWorkVoucher.devcSetupInfo.devcSetupItemList != null &&
      _vm.servcWorkVoucher.devcSetupInfo.devcSetupItemList.length > 0
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "15px",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "text-align": "center",
                    padding: "15px 0"
                  }
                },
                [_vm._v("安装信息")]
              ),
              _vm._v(" "),
              _vm._l(
                _vm.servcWorkVoucher.devcSetupInfo.devcSetupItemList,
                function(devcSetupItem) {
                  return _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        border: "1px solid rgb(26, 26, 26)",
                        "margin-top": "10px",
                        padding: "5px 2px 10px 2px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            width: "33.33%",
                            float: "left",
                            "margin-top": "5px",
                            "font-size": "12px",
                            "word-break": "break-all",
                            "word-wrap": "break-word"
                          }
                        },
                        [
                          _vm._m(24, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all",
                                "word-wrap": "break-word",
                                color: "#666666"
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(devcSetupItem.devcXN))])]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            width: "33.33%",
                            float: "left",
                            "margin-top": "5px",
                            "font-size": "12px"
                          }
                        },
                        [
                          _vm._m(25, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all",
                                "word-wrap": "break-word",
                                color: "#666666"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    devcSetupItem.shopDeviceSvcSubNo.vendorUkno
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            width: "33.33%",
                            float: "left",
                            "margin-top": "5px",
                            "font-size": "12px"
                          }
                        },
                        [
                          _vm._m(26, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all",
                                "word-wrap": "break-word",
                                color: "#666666"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    devcSetupItem.shopDeviceSvcSubNo.sellerName
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            width: "33.33%",
                            float: "left",
                            "margin-top": "5px",
                            "font-size": "12px"
                          }
                        },
                        [
                          _vm._m(27, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all",
                                "word-wrap": "break-word",
                                color: "#666666"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(devcSetupItem.extraInfo))
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            width: "33.33%",
                            float: "left",
                            "margin-top": "5px",
                            "font-size": "12px"
                          }
                        },
                        [
                          _vm._m(28, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all",
                                "word-wrap": "break-word",
                                color: "#666666"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(devcSetupItem.asmblFlag ? "是" : "否")
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            width: "33.33%",
                            float: "left",
                            "margin-top": "5px",
                            "font-size": "12px"
                          }
                        },
                        [
                          _vm._m(29, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all",
                                "word-wrap": "break-word",
                                color: "#666666"
                              }
                            },
                            [
                              devcSetupItem.asmblFlag
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        devcSetupItem.asmblDone ? "是" : "否"
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            width: "33.33%",
                            float: "left",
                            "margin-top": "5px",
                            "font-size": "12px"
                          }
                        },
                        [
                          _vm._m(30, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "54px",
                                "white-space": "normal",
                                "word-break": "break-all",
                                "word-wrap": "break-word",
                                color: "#666666"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    devcSetupItem.asmblWhileSetup ? "是" : "否"
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcOrderItemList != null
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("服务订单信息")]
            ),
            _vm._v(" "),
            _vm._l(_vm.servcWorkVoucher.servcOrderItemList, function(
              servcOrderItem
            ) {
              return _c(
                "div",
                {
                  staticStyle: {
                    overflow: "hidden",
                    border: "1px solid rgb(26, 26, 26)",
                    "margin-top": "10px",
                    padding: "5px 2px 10px 2px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(31, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcOrderItem.title))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(32, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcOrderItem.catName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(33, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcOrderItem.amount))])]
                      )
                    ]
                  )
                ]
              )
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl mt10",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c(
            "tbody",
            { staticClass: "body" },
            [
              _vm._m(34),
              _vm._v(" "),
              _vm.servcWorkVoucher.deviceFlag
                ? [
                    _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(35),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.servcWorkVoucher.tmpNo || "无")
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(36),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.servcWorkVoucher.vendorUkno || "无"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(37),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.servcWorkVoucher.deviceName || "无"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(38),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.servcWorkVoucher.deviceCatName ||
                                          "无"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(39),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.servcWorkVoucher
                                          .devcGroupFullName || "无"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(40),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.servcWorkVoucher.deviceBrandName ||
                                          "无"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(41),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.servcWorkVoucher.departName || "无"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "info-item ",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _vm._m(42),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    "padding-left": "54px",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.servcWorkVoucher.devcLocCode || "无"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.servcWorkVoucher.devcVendorSn != null ||
              _vm.servcWorkVoucher.servcWorkDeviceParts != null
                ? _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(43),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _vm.servcWorkVoucher.devcVendorSn != null
                                  ? _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.servcWorkVoucher.devcVendorSn ||
                                            "无"
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(44),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              _vm._l(
                                _vm.servcWorkVoucher.servcWorkDeviceParts,
                                function(servcWorkDevicePart, index) {
                                  return _c("label", [
                                    _vm._v(_vm._s(servcWorkDevicePart.partName))
                                  ])
                                }
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkAccItemList != null &&
      _vm.servcWorkVoucher.servcWorkAccItemList.length > 0
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("配件信息")]
            ),
            _vm._v(" "),
            _vm._l(_vm.servcWorkVoucher.servcWorkAccItemList, function(
              servcWorkAccItem
            ) {
              return _c(
                "div",
                {
                  staticStyle: {
                    overflow: "hidden",
                    border: "1px solid rgb(26, 26, 26)",
                    "margin-top": "10px",
                    padding: "5px 2px 10px 2px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(45, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcWorkAccItem.accName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(46, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkAccItem.quantity))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(47, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcWorkAccItem.unit))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(48, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                servcWorkAccItem.shareAccFlag ? "是" : "否"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(49, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                servcWorkAccItem.mountFlag == 1
                                  ? "换上"
                                  : "换下"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(50, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkAccItem.vendorSn))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(51, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "更换了" +
                                _vm._s(servcWorkAccItem.replacedVendorSn)
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(52, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkAccItem.replaceDesc))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(53, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcWorkAccItem.price))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(54, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcWorkAccItem.amount))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(55, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkAccItem.accClaim.price))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(56, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkAccItem.accClaim.price2))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(57, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          servcWorkAccItem.refAccClaimId != null &&
                          servcWorkAccItem.refAccClaimId != -1 &&
                          !servcWorkAccItem.shareAccFlag
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    servcWorkAccItem.metFlag ? "满足" : "不满足"
                                  )
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.spotImageUrl != null &&
      _vm.servcWorkVoucher.spotImageUrl.length > 0
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("现场图片")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  border: "1px solid rgb(26, 26, 26)",
                  "margin-top": "10px",
                  padding: "5px 2px 10px 2px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      overflow: "hidden",
                      width: "100%",
                      float: "left",
                      "margin-top": "5px",
                      "font-size": "12px",
                      "word-break": "break-all",
                      "word-wrap": "break-word"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "54px",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "word-wrap": "break-word",
                          color: "#666666"
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "120px", height: "120px" },
                          attrs: { src: _vm.servcWorkVoucher.spotImageUrl }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkRepairImgFileList != null &&
      _vm.servcWorkVoucher.servcWorkRepairImgFileList.length > 0
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.servcWorkVoucher.servcType == 2 ? "安装" : "问题"
                  ) + "图片"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  border: "1px solid rgb(26, 26, 26)",
                  "margin-top": "10px",
                  padding: "5px 2px 10px 2px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      overflow: "hidden",
                      width: "100%",
                      float: "left",
                      "margin-top": "5px",
                      "font-size": "12px",
                      "word-break": "break-all",
                      "word-wrap": "break-word"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "54px",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "word-wrap": "break-word",
                          color: "#666666"
                        }
                      },
                      _vm._l(
                        _vm.servcWorkVoucher.servcWorkRepairImgFileList,
                        function(servcWorkImgFile) {
                          return _c("img", {
                            staticStyle: { width: "120px", height: "120px" },
                            attrs: { src: servcWorkImgFile.fileBrowseUrl }
                          })
                        }
                      )
                    )
                  ]
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkImgFileList != null &&
      _vm.servcWorkVoucher.servcWorkImgFileList.length > 0
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("完成图片")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  border: "1px solid rgb(26, 26, 26)",
                  "margin-top": "10px",
                  padding: "5px 2px 10px 2px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      overflow: "hidden",
                      width: "100%",
                      float: "left",
                      "margin-top": "5px",
                      "font-size": "12px",
                      "word-break": "break-all",
                      "word-wrap": "break-word"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "54px",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "word-wrap": "break-word",
                          color: "#666666"
                        }
                      },
                      _vm._l(
                        _vm.servcWorkVoucher.servcWorkImgFileList,
                        function(servcWorkImgFile) {
                          return _c("img", {
                            staticStyle: { width: "120px", height: "120px" },
                            attrs: { src: servcWorkImgFile.fileBrowseUrl }
                          })
                        }
                      )
                    )
                  ]
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl mt10",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px",
                    "text-align": "center",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "background-color": "#efefef",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "4" }
                },
                [
                  _c("span", [
                    _vm._v(
                      "费用信息 （总费用(元)：" +
                        _vm._s(_vm.servcWorkVoucher.amount) +
                        "）"
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(58),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.freeFlag
                            ? _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-success" },
                                [_vm._v("免费")]
                              )
                            : _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-danger" },
                                [_vm._v("收费")]
                              )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(59),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.toDoorFee == null
                                  ? "无"
                                  : _vm.servcWorkVoucher.toDoorFee
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(60),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.generallFee == null
                                  ? "无"
                                  : _vm.servcWorkVoucher.generallFee
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(61),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.accFee == null
                                  ? "无"
                                  : _vm.servcWorkVoucher.accFee
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl mt10",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(62),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(63),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.buyerName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(64),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.buyerBizUnitName)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(65),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(66),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.buyerShopNo || "")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(67),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.requesterStaffName)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(68),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.requesterContactTel)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(69),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopAddr))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(70),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.buyerShopContactTel)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  },
                  attrs: { colspan: "2" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(71),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.requestDesc || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  },
                  attrs: { colspan: "2" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.servcType == 2
                            ? _c("span", [_vm._v("安装说明")])
                            : _vm.servcWorkVoucher.servcType == 3 ||
                              _vm.servcWorkVoucher.servcType == 5
                            ? _c("span", [_vm._v("描述")])
                            : _c("span", [_vm._v("情况描述")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.troubleDesc != null
                            ? _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.troubleDesc || "无"
                                  )
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(72),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.planTime || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(73),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.planTime || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(74),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.yqArriveTimeMi || "无"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(75),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.yqRepairedTimeMi || "无"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(76),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.reqTelCallTimeMi || "无"
                              ) + "(分钟)"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(77),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.planStartOffTime || "无"
                              ) + "(分钟)"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(78),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.estiFinishTime || "无"
                              ) + "(分钟)"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(79),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.rspTimeMi == null
                                  ? "无"
                                  : _vm.servcWorkVoucher.rspTimeMi
                              ) + "(分钟)"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(80),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.arriveTimeMi == null
                                  ? "无"
                                  : _vm.servcWorkVoucher.arriveTimeMi
                              ) + "(分钟)"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(81),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.repairedTimeMi == null
                                  ? "无"
                                  : _vm.servcWorkVoucher.repairedTimeMi
                              ) + "(分钟)"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  },
                  attrs: { colspan: "2" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(82),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.rspTelCallTimeMi == null
                                  ? "无"
                                  : _vm.servcWorkVoucher.rspTelCallTimeMi
                              ) + "(分钟)"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl mt10",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(83),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(84),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.servcWorkVoucher.servicerName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(85),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.servicerShopName)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(86),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.servicerShopContractTel
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(87),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.servicerShopContractName ||
                                  ""
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl mt10",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(88),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(89),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.engineerName || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(90),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.engineerNames || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(91),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.contactTel || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(92),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.toDoorTime || "")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.servcWorkVoucher.contractId != null
        ? [
            _c(
              "table",
              {
                staticClass: "simple-tbl mt10",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px",
                  "word-break": "break-strict"
                }
              },
              [
                _c("tbody", { staticClass: "body" }, [
                  _vm._m(93),
                  _vm._v(" "),
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "2" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(94),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.contractNo || "无"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "2" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(95),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.contractOriginalNo ||
                                        "无"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.tradeId != null
        ? [
            _c(
              "table",
              {
                staticClass: "simple-tbl mt10",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px",
                  "word-break": "break-strict"
                }
              },
              [
                _c("tbody", { staticClass: "body" }, [
                  _vm._m(96),
                  _vm._v(" "),
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(97),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.servcWorkVoucher.tradeNo || "无")
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(98),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.tradeTypeMap[
                                        _vm.servcWorkVoucher.tradeType
                                      ]
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "2" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(99),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.trackPhaseName || ""
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.finished
        ? [
            _c(
              "table",
              {
                staticClass: "simple-tbl mt10",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px",
                  "word-break": "break-strict"
                }
              },
              [
                _c("tbody", { staticClass: "body" }, [
                  _vm._m(100),
                  _vm._v(" "),
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(101),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.faultTypeName || "无"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "2" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(102),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.faultDesc || "无"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(103),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.repairTypeName || ""
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "2" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(104),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.finishTime || "无"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        },
                        attrs: { colspan: "2" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info-item ",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _vm._m(105),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.servcWorkVoucher.handleResult || "无"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucherRecList != null &&
      _vm.servcWorkVoucherRecList.length > 0
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("工单操作记录")]
            ),
            _vm._v(" "),
            _vm._l(_vm.servcWorkVoucherRecList, function(servcWorkVoucherRec) {
              return _c(
                "div",
                {
                  staticStyle: {
                    overflow: "hidden",
                    border: "1px solid rgb(26, 26, 26)",
                    "margin-top": "10px",
                    padding: "5px 2px 10px 2px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(106, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkVoucherRec.actorName))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(107, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkVoucherRec.action))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(108, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkVoucherRec.actRole))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(109, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(servcWorkVoucherRec.extraInfo))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(110, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcWorkVoucherRec.loc))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(111, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(servcWorkVoucherRec.ts))])]
                      )
                    ]
                  )
                ]
              )
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.finished &&
      (_vm.servcWorkVoucher.servcType == 0 ||
        _vm.servcWorkVoucher.servcType == 1 ||
        _vm.servcWorkVoucher.additionFlag)
        ? [
            _c("swb-servc-work-add-item-list", {
              ref: "swb_servc_work_add_item_list",
              attrs: { id: _vm.voucherId }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.devcInspectFlag &&
      _vm.servcWorkVoucher.devcInspectInfo != null
        ? [
            _c(
              "div",
              {
                staticClass: "order-tmp-caption",
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("检验签字信息")]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "simple-tbl",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px"
                }
              },
              [
                _c("tbody", { staticClass: "body" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(112),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 160px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.devcInspectInfo
                                      .handoverOutRcvName
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "sign-name",
                            staticStyle: {
                              height: "160px",
                              "text-align": "center"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { height: "160px" },
                              attrs: {
                                src:
                                  _vm.servcWorkVoucher.devcInspectInfo
                                    .handoverOutRcvSigUrl
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(113),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value align-right",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 86px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    new Date(
                                      _vm.servcWorkVoucher.devcInspectInfo.inspectDate
                                    ).format("yyyy年MM月dd日")
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(114),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 160px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.devcInspectInfo
                                      .handoverInRcvName
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "sign-name",
                            staticStyle: {
                              height: "160px",
                              "text-align": "center"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { height: "160px" },
                              attrs: {
                                src:
                                  _vm.servcWorkVoucher.devcInspectInfo
                                    .handoverInRcvSigUrl
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(115),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value align-right",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 86px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm.servcWorkVoucher.devcInspectInfo
                                .inspectDate != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        new Date(
                                          _vm.servcWorkVoucher.devcInspectInfo.inspectDate
                                        ).format("yyyy年MM月dd日")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.devcMaintFlag
        ? [
            _c("swb-servc-work-devc-maint-voucher-list", {
              ref: "swb_servc_work_devc_maint_voucher_list",
              attrs: { id: _vm.voucherId }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("基本信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("工单编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("是否委托")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("是否委托")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("工单来源")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("约检完成")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("约检完成时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("约保完成")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("约保完成时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("交易单号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("维修部件")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("紧急状态")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("工单模式")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("工单状态")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求单编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("工单截止时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("工单创建时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("工单创建人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("指派网点")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("指派工程师")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("是否约定期保外")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("仅报修人验收")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("业务标签")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("设备编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("商品标识码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("卖家名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("其他信息")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("含组装商品")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("是否组装完成")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("安装时完成组装")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("服务名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("服务分类")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("价格(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("设备信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("系统编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("商品标识码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("设备名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("设备分类")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("维保分组")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("设备品牌")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("所在部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("位置编码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("厂商序列号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("部件名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("配件名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("个数")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("单位")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("自用")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("拆卸标记")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("厂商序列号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("更换信息")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("更换说明")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("单价(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("价格(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("要求价格下限(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("要求价格上限(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("要求是否满足")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("是否免费")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("上门费(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("服务费(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("配件费(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("请求信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("服务请求方")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("业务单元")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求机构编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求人电话")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求地址")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求机构联系电话")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("请求描述")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("预约上门时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("要求响应时长")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("要求到达时长")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("要求完成时长")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("要求回询时限")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("计划出发时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("预计完成时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("实际响应时长")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("实际到达时长")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("实际完成时长")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("实际回询时限")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("服务网点信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("服务商名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("服务网点名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("网点联系电话")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("网点联系人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("工程师信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("主工程师")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("辅助工程师")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("主工程师联系电话")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("到达时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("合同信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("合同号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("原始合同号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("交易信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("交易单号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("交易类型")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("指标跟踪阶段")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "4" }
        },
        [_c("span", [_vm._v("工单处理信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("故障类型")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("故障描述")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("维修类型")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("服务完成时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("处理结果")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作人身份")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("附加信息")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作位置")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "160px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("交出接收人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("检验日期")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "160px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("交回接收人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("检验日期")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ebdf01e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ebdf01e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherPdf.vue
// module id = 1873
// module chunks = 1